import React from "react";
import BankInboxRow from "./BankInboxRow";
import "../../finance.css";

const DEFAULT_KINDS = ["service", "kontur", "expense", "liability", "payroll", "dismiss"];

export default function BankInbox({
  items = [],
  kinds = DEFAULT_KINDS,
  options = {},
  onResolve,
  title = "Не разобрано в банке",
}) {
  return (
    <div className="bank-inbox" aria-label={title}>
      {items.length === 0 ? (
        <p className="cp-inbox-note">Нет неразобранных операций</p>
      ) : (
        <ul className="cp-inbox-list">
          {items.map((item) => (
            <BankInboxRow
              key={item.id}
              item={item}
              kinds={kinds}
              options={options}
              onResolve={onResolve}
            />
          ))}
        </ul>
      )}
    </div>
  );
}
